// ====================
// components/AboutSection.js
// ====================

import React from 'react';
import { Code, Server } from 'lucide-react';

const AboutSection = () => {
  const highlights = [
    {
      icon: <Code size={32} />,
      title: 'Full-Stack Development',
      description: 'Experience with React Native, C++, Python, and database management'
    },
    {
      icon: <Server size={32} />,
      title: 'System Administration',
      description: 'Proficient in Active Directory, Microsoft 365, and enterprise IT solutions'
    }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2>About Me</h2>
        
        <div className="about-content">
          <div className="about-text">
            <p>
              Hi, I'm Nicole Amaral, a Computer Science student at Champlain College with a particular passion for privacy and security. I am
              Currently maintaining a 3.94 GPA while pursuing my Bachelor's degree with a minor in Cybersecurity. I've consistently 
              earned recognition on the Dean's List and President's List for academic excellence. I try to balance my studies with getting 
              out in the world, whether that's hiking, rollerskating, biking, or just exploring new places. Reading is another
              way I slow down from the fast paced tech world and immerse myself in different stories and ideas.
            </p>
            
            <p>
              Through hands-on 
              experience as an IT Analyst at the Leahy Center for Digital Forensics and Cybersecurity, I've developed practical 
              skills in system administration and client support. My research work in IoT device extraction 
              has given me valuable experience in backend development and collaborative software engineering.
            </p>
            
            <p>
              In regards to the future, I'm excited to pursue a career where I can combine my technical skills with my passion for 
              cybersecurity; no matter the job, I hope to be helping people whenever I can! I'm eager to contribute to a team that values 
              continuous learning and collaboration.
            </p>
          </div>
          
          <div className="about-highlights">
            {highlights.map((highlight, index) => (
              <div key={index} className="highlight-card">
                {highlight.icon}
                <h3>{highlight.title}</h3>
                <p>{highlight.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;